import { ContactGroup } from '@frontend/contact-group';
import { TransactionContactGroup } from '@frontend/transaction';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { MdGroups } from 'react-icons/md';

import { DetailModalType } from '../../modals/detail-modal/detail-modal-container/detail-modal-container.controller';
import BadgeTemplate from '../badge-template/badge-template.component';
import useContactGroupBadge from './contact-group-badge.controller';

export interface ContactGroupBadgeProps {
    contactGroupId?: string;
    contactGroup?: ContactGroup | TransactionContactGroup;
    name?: string;
}

const ContactGroupBadge = (props: ContactGroupBadgeProps) => {
    const viewProps = useContactGroupBadge(props);
    if (viewProps.name.split(',').length > 1) {
        return (
            <OverlayTrigger
                delay={{ show: 300, hide: 150 }}
                overlay={
                    <Tooltip id='tooltip'>
                        <div className='d-flex flex-column justify-content-start align-items-start align-items-start'>
                            {viewProps.name.split(',').map((name, index) => (
                                <p
                                    key={index}
                                    className='m-0'>
                                    {name}
                                </p>
                            ))}
                        </div>
                    </Tooltip>
                }>
                <BadgeTemplate
                    objectId={props.contactGroupId}
                    type={DetailModalType.CONTACT_GROUP}>
                    {<MdGroups />}
                    {viewProps.name.split(',')[0]} + {viewProps.name.split(',').length - 1} more
                </BadgeTemplate>
            </OverlayTrigger>
        );
    }
    return (
        <BadgeTemplate
            objectId={props.contactGroupId}
            type={DetailModalType.CONTACT_GROUP}>
            {<MdGroups />}
            {viewProps.name}
        </BadgeTemplate>
    );
};

export default ContactGroupBadge;
